import Vue from 'vue';
import useVueCompositionApi from '@/js/common/plugins/use-vue-composition-api';
import SpecialOfferBanner from './SpecialOfferBanner.vue';

useVueCompositionApi();

function initSpecialOfferBanner() {
    const containers = document.querySelectorAll('.js-special-offer-banner');

    containers.forEach(container => {
        if (container && !container.__vueInstance) {
            container.__vueInstance = new Vue({
                render: (h) => h(SpecialOfferBanner),
            }).$mount(container);
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSpecialOfferBanner);
} else {
    initSpecialOfferBanner();
}

export default initSpecialOfferBanner;
